import { httpApi } from '@api/http.api.ts';
import type { UserPreferencesSettings } from '@types';

export type UpdateUserPreferencesRequest = UserPreferencesSettings;

export const requestUserDataDeletion = (): Promise<any> => httpApi.delete<any>(`me`).then(({ data }) => data);

export const updateUserPreferences = (UpdateUserConsentPayload: UpdateUserPreferencesRequest): Promise<any> =>
    httpApi.put<any>(`preferences`, { ...UpdateUserConsentPayload }).then(({ data }) => data);
